<template>
    <v-card
            max-width="600"
            width="600"
            class="mx-auto"
    >
        <v-card-title class="error">
            <v-icon
                    large
                    left
                    color="white"
            >
                error
            </v-icon>
            <span class="title white--text">Fehler beim Bezahlen</span>
        </v-card-title>
        <v-card-text>
            <p>Leider konnten wir den Bezahlvorgang für Ihre Bestellung nicht abschließen. Ihnen wurde kein Geld abgebucht.</p>
            <p>Bitte geben Sie Ihre Daten erneut ein um die Bestellung abzuschließen.</p>
            <p>Bei wiederholter Fehlermeldung treten Sie bitte mit uns in Kontakt.</p>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" :href="'/checkout/'+event">
                zum bestellformular</v-btn>
            <v-btn color="secondary" outline href="https://www.marburger-bund.de/kontakt">
                Kontakt</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "PriceBox",
        props: {
            event: String,
        },
        computed: {},
    }
</script>

<style scoped>

</style>
